<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      v-model="form"
      ref="crud"
      :page.sync="page"
      :search.sync="form"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
      @sort-change="sortChange"
    >
      <template slot="search" slot-scope="{ row, size }">
        <div class="block">
          <el-form-item label="模糊搜索" style="margin-left: 15px">
            <el-input
              v-model="form.search"
              width="150px"
              placeholder="合同编号/合同名称/所属项目"
            ></el-input
          ></el-form-item>
        </div>
      </template>
      <template slot="searchMenu" slot-scope="{ row, size }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button  type="primary"  @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      <template slot="menuRight" slot-scope="scope">
   
      
   <el-tooltip
         class="item"
         effect="dark"
         content="显隐"
         placement="top"
       >
         <el-button
           icon="el-icon-s-operation"
           circle
           @click="operation"
         ></el-button>
       </el-tooltip>
</template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="success"
          plain
          size="small"
          icon="el-icon-arrow-right"
          @click.stop="handleDetails(scope.row.id)"
          >详情
        </el-button>
      </template>
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="expectUseDay">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.expectUseDayMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.expectUseDayMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="quota">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.quotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
    <Options
          ref="Options"
          :plainOptions="optionColumn"
          :pageDataId="this.$route.path"
          @returnData="returnData"
        />
  </div>
</template>

<script>
import * as api from "@/api/zd/contract";
import SelectPerson from "@/components/SelectPersonnel/person";
import Options from "@/components/ShowHidden/showhidden";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      optionColumn: [],
      shlb: 0,
      form: {},
      drawer: false,
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      data: [],

      customerName: [],

      option: {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        refreshBtn:false,
        // menuWidth: 300,
        labelWidth: 100,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "银行编号/银行名称/联系信息",
            placeholder: "银行编号/银行名称/联系信息",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow:true
           
          },
          {
            sortable: "custom",
            label: "合同编号",
            prop: "number",
            width: "120",
            fixed: true,
            display:false
          },
          {
            label: "合同名称",
            prop: "contractName",
            width: "180",
            fixed: true,
            display:false
          },
          {
            label: "所属项目",
            prop: "projectName",
            width: "180",
            display:false,
          },
          {
            label: "客户名称",
            prop: "custName",
            width: "160",
            display:false,
            hideshow:true
          },
          {
            label: "客户名称",
            prop: "custId",
            width: "160",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/blade-/zd/custom/basicInformations",
            dicMethod: "post",
            dicQuery: {
              type: 0,
            },
            props: {
              label: "custName",
              value: "id",
            },
            dataType: "string",
            search: true,
            hide: true,
          },
          {
            label: "合同金额",
            sortable: "custom",
            prop: "quota",
            width: "160",
            formslot: true,
            formatter: (row, value, label, column) => {
              if (value == -1) {
                return "-";
              } else {
                return this.getMoney(value);
              }
            }
          },
          {
            label: "申请银行",
            prop: "bankName",
            width: 160,
            overHidden: true,
            display: false,
          },
          {
            label: "申请银行",
            prop: "bankId",
            hide: true,
            width: "160",
            type: "select",
            filterable: "true",
            dicUrl: "/api/blade-/zd/bank/getListDefault",
            dicMethod: "post",
            dicQuery: {
              type: 0,
            },
            props: {
              label: "bankName",
              value: "id",
            },
            dataType: "string",
          },
          {
            label: "使用天数",
            prop: "expectUseDay",
            formslot: true,
          },
          {
            label: "使用费率",
            prop: "loanRate",
            width: "150",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            display: true,
          },
          {
            label: "预计出款日期",
            prop: "expectPayDate",
            width: "180",
            type: 'data',
            display: false,
          },
          {
            label: "预计出款日期",
            prop: "expectPayDate1", 
            type: "daterange",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
            hide: true,
            display: true,
            search: false,
            hideshow: true,
          },
          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,

            search: true,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick();
            },
          },
          {
            label: "合同申请",
            prop: "wfStatus",
            width: "160",
            type: "select",
            display:false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
          },

          {
            label: "归档状态",
            prop: "auditState",
            width: "160",
            type: "select",
            display:false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
            props: {
              label: "dictValue",
              value: "dictKey",
            },

            dataType: "number",
            formatter: (row, value, label, column) => {
              if (row.wfStatus < 2) {
                return "-";
              } else if (label == "审核通过") {
                return "已归档";
              } else {
                return label;
              }
            },
          },
        ],
      },
    };
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: ["files"],
  components: { 
  Options,SelectPerson
},
  mounted() {
    this.optionColumn = this.deepClone(this.option.column)
  },
  activated() {
    this.onLoad(this.page)
  },
  methods: {
    //显隐
    operation() {
      let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },
    returnData(data) {
      
      // this.$emit("showoption",data)
      this.option.column = data;
    },
    //排序
    sortChange(val) {
      this.form.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.form.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    onLoad(page) {
      
      if(this.form.expectPayDate1!=undefined){
        this.form.dateMin=this.form.expectPayDate1[0]
        this.form.dateMax=this.form.expectPayDate1[1]
      }
      delete this.form["expectPayDate1"];
      delete this.form["expectPayDate"];
      api
        .getListcontract({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.form,
          auditState: 1,
        })
        .then((res) => {
          
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch((res) => {
          
        });
    },
    searchChange(params, done) {
      

      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form={ }
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen(){
      this.$refs.crud.searchReset()
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      
      this.form = data;
      this.searchChange(data);
    },
    handleDetails(id) {
      
      this.$router.push({
        path: "/zd/contractmanage/contractDetail/",
        query: { id: id },
      });

      // this.$router.push({ path: `/zd/contractmanage/contractDetail/${id}` });
    },
    handleEdit(id) {
      
      if (id == "-1") {
        this.$router.push({ path: `/zd/contractmanage/add/-1` });
      } else {
        this.$router.push({ path: `/zd/contractmanage/edit/${id}` });
      }
    },
    exportout() {
      let data = this.form;
      data.firstNum = "";
      data.num = "";
      delete data["$auditState"];
      delete data["$bankState"];
      let exceldata = this.daochu(data);

      this.$export.excel({
        title: "银行管理",
        columns: this.option.column,
        data: exceldata,
      });
    },
    
    daochu(data) {
      api.bankmessagegetList(data).then((res) => {
        return res.data.data.list;
      });
    },
    cutomerchange(data) {
      
      console.log(data);
    },
    handleDel(id) {
      
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .deleteonlist({ id: id })
            .then((res) => {
              
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.onLoad(this.page);
            })
            .catch((res) => {
              
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.form = { ...this.form, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserName = people.join(",");
        this.form.managerUserIds = ids.join(",");
      });
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
  },
};
</script>

<style lang="scss" scoped>
.crudblock {
  background: #ffff;
 padding:16px;
 border-radius: 4px;
}
/deep/ .avue-group--card:last-child{
  margin-bottom:0px ;
}
</style>
